import { API } from "@API/API";
import { urlFunctions } from "@API/functions/createUrl";

import { AdminStudy } from "@lib/Types/AdminData/AdminEntitiyList";

type AdminStudyListType =
  | {
      success: true;
      data: AdminStudy[];
    }
  | {
      success: false;
      data: string;
    };

export const getAdminStudyList = async function (
  id: string
): Promise<AdminStudyListType> {
  const url = urlFunctions.getAdminStudyList(id);
  const res = await API.sendGetRequest(url);
  if (res.success) {
    const data: AdminStudy[] = res.data;
    return {
      success: true,
      data: data,
    };
  } else {
    return {
      success: false,
      data: "There was an error in getting study list",
    };
  }
};
